// extracted by mini-css-extract-plugin
export default {"slick":"Reviews_slick__mFk4E","slider-div":"Reviews_slider-div__F0Bgn","star":"Reviews_star__ieAec","review":"Reviews_review__155fo"};